import { array, mixed, number, object } from 'yup';

import { YUP_ERRORS_MESSAGES } from '@shared/constants';
import { getRewardValueValidationSchema } from '@shared/utils';

import { UserRewardType } from 'v2/constants';
import { FormReward } from 'v2/types';
import { SpecialDropType } from 'v2/types/SpecialDropModel';

export interface SpecialDropFormValues {
  chanceToWin: number;
  type: SpecialDropType;
  rewards: FormReward[];
}

export const getSpecialDropFormInitialValues = (type: SpecialDropType): SpecialDropFormValues => ({
  chanceToWin: 0.05,
  type,
  rewards: [{ type: UserRewardType.BALANCE, value: '', count: 1 }],
});

export const specialDropValidationSchema = object().shape({
  chanceToWin: number().min(0).max(100).required(YUP_ERRORS_MESSAGES.REQUIRED),
  rewards: array().of(
    object().shape({
      type: mixed().oneOf(Object.values(UserRewardType)).required(YUP_ERRORS_MESSAGES.REQUIRED),
      value: getRewardValueValidationSchema(),
      count: number().min(1),
    })
  ),
});
